import { useBrowserModalControls } from '@telialt/common-hooks/src/useBrowserModalControls';
import { VasProduct } from '@telialt/models/src/EshopModel';

const READ_AND_CLOSE_VAS_MODAL = 'readAndCloseModalForVAS';

export const useVasModalControls = () => useBrowserModalControls<VasProduct>(READ_AND_CLOSE_VAS_MODAL);
